import { Navigate, Route, Routes } from "react-router-dom";
import { AutomationPage } from "./AutomationPage";
import { ComposePage } from "./ComposePage";
import { EmailsPage } from "./EmailsPage";
import { MailboxesPage } from "./MailboxesPage";
import { TemplatesPage } from "./TemplatesPage";
import { ThreadPage } from "./ThreadPage";

export function EmailsRoutes() {
  return (
    <Routes>
      <Route index element={<EmailsPage />} />
      <Route path="new" element={<ComposePage />} />
      <Route path="automation" element={<AutomationPage />} />
      {/* Wording sits with the mailbox that sends it rather than with the mail driver that
          carries it, so the people who write to customers can find it. */}
      <Route path="templates" element={<TemplatesPage />} />
      <Route path="mailboxes" element={<MailboxesPage />} />
      <Route path=":threadId" element={<ThreadPage />} />
      <Route path="*" element={<Navigate to="/emails" replace />} />
    </Routes>
  );
}
